import React from 'react';
import ROUTES from 'routes/constants';
import DocumentSign from '@quintoandar/cozy-icons/DocumentSign';
import CameraPlusIcon from '@quintoandar/cozy-icons/AddAPhoto';
import CameraIcon from '@quintoandar/cozy-icons/Camera';
import VideoCamera from '@quintoandar/cozy-icons/VideoCamera';
import Checklist from 'containers/Checklist';
import Photosphere from 'containers/PhotosManager/Photosphere';
import Photo from 'containers/PhotosManager/Photo';
import { uploadVideoLinkAction } from 'containers/Video/action';
import { updatePhotosAction } from 'containers/PhotosManager/action';
import { mountPhotoSessionIdQueryParam } from 'containers/AnnouncementSteps/url';
import messages from '../../../containers/AnnouncementSteps/messages';
import Video from '../../../containers/Video';
import { getProgress } from '../../../containers/Checklist/progress';
import { openFinishSessionDialog, updateIsChecklistValidAction } from '../../../containers/Checklist/actions';

export const steps = [
  {
    id: 'checklist',
    routeRegex: /.\/new-checklist\/./,
    tab: {
      active: true,
      icon: DocumentSign,
      title: messages.statusListChecklistStepTitle,
      description: messages.statusListChecklistStepDescription,
    },
    route: (params) =>
      `${ROUTES.NEW_CHECKLIST(params.photoSessionId)}?house_id=${params.houseId}&house_type=${params.houseType}`,
    isComplete: true,
    buttonMessage: messages.checklistStepButtonTitle,
    action:
      ({ checklist, assessment }) => {
        const progress = getProgress({ checklist, assessment });
        const shouldFinish = progress.total !== 0 &&
          progress.total === progress.current &&
          checklist.fixed.house.items.tipo &&
          checklist.fixed.house.items.tipo.value !== undefined;

        if (shouldFinish) {
          return openFinishSessionDialog();
        }

        return updateIsChecklistValidAction(false);
      },
    actionParams: 'checklist',
    order: 1,
    renderComponent: (params, additionalProps) =>
      <Checklist params={params} additionalProps={additionalProps} shouldNotShowComponents />,
  },
  {
    id: 'photo',
    routeRegex: /.\/photo\/./,
    tab: {
      active: true,
      icon: CameraPlusIcon,
      title: messages.statusListPhotoStepTitle,
      description: messages.statusListPhotoStepDescription,
    },
    route: (params) =>
      `${ROUTES.PHOTOS_MANAGER(params.houseType, params.houseId)}${mountPhotoSessionIdQueryParam(params.photoSessionId)
      }`,
    isComplete: true,
    buttonMessage: messages.photoStepButtonSave,
    action: (list, houseId) => updatePhotosAction(list, 'photo', houseId),
    actionParams: 'photolist',
    order: 2,
    showMobileDialog: true,
    renderComponent: (params, additionalProps, isMobile) =>
      <Photo params={params} additionalProps={additionalProps} isMobile={isMobile} />,
  },
  {
    id: 'video',
    routeRegex: /.\/video\/./,
    tab: {
      active: true,
      icon: VideoCamera,
      title: messages.statusListVideoStepTitle,
    },
    route: (params) =>
      `${ROUTES.VIDEOS(params.houseType, params.houseId)}${mountPhotoSessionIdQueryParam(params.photoSessionId)}`,
    isComplete: true,
    buttonMessage: messages.videoStepButtonTitle,
    action: (houseType, houseId, url, videoSource) => uploadVideoLinkAction(houseType, houseId, url, videoSource),
    actionParams: 'url',
    order: 3,
    showMobileDialog: true,
    renderComponent: (params, additionalProps, isMobile) =>
      <Video params={params} additionalProps={additionalProps} isMobile={isMobile} />,
  },
  {
    id: 'photosphere',
    routeRegex: /.\/photosphere\/./,
    tab: {
      active: true,
      icon: CameraIcon,
      title: messages.statusListPhotosphereStepTitle,
    },
    route: (p) =>
      `${ROUTES.PHOTOS_MANAGER_PHOTOSPHERE(p.houseType, p.houseId)}${mountPhotoSessionIdQueryParam(p.photoSessionId)}`,
    isComplete: true,
    buttonMessage: messages.photosphereStepButtonSave,
    action: (list) => updatePhotosAction(list, 'photosphere'),
    actionParams: 'photolist',
    order: 4,
    showMobileDialog: true,
    renderComponent: (params, additionalProps, isMobile) =>
      <Photosphere params={params} additionalProps={additionalProps} isMobile={isMobile} />,
  },
];
